import React, { useEffect, useState } from 'react';
import { Toaster } from 'sonner';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { HowItWorks } from './components/HowItWorks';
import { Benefits } from './components/Benefits';
import { FAQ } from './components/FAQ';
import { Stats } from './components/Stats';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WaitlistModal } from './components/WaitlistModal';
export function App() {
  useEffect(() => {
    document.title = 'Lighthouse AI — Automated Driver Hiring';
  }, []);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [signupEmail, setSignupEmail] = useState('');
  const handleSignup = (email: string) => {
    setSignupEmail(email);
    setIsModalOpen(true);
  };
  return <div className="min-h-screen bg-white font-sans selection:bg-blue-500/30" data-id="element-0">
      <Toaster position="top-center" richColors data-id="element-1" />
      <Navbar data-id="element-2" />
      <main data-id="element-3">
        <Hero onSignup={handleSignup} data-id="element-4" />
        <PainPoints data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <Benefits data-id="element-7" />
        <FAQ data-id="element-8" />
        <Stats data-id="element-9" />
        <FinalCTA onSignup={handleSignup} data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <WaitlistModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} email={signupEmail} data-id="element-12" />
    </div>;
}